import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class AchievementsClassification extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "achievementsCount", Model.attribute('achievementsCount'));
    _defineProperty(this, "totalAchievements", Model.attribute('totalAchievements'));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/AchievementsClassification', AchievementsClassification);